<template>
  <div class="acs-container">
    <h1 class="page-title">Insights</h1>

    <ErrorBanner />

    <loading-icon v-if="isLoading" />

    <div id="quicksight-container"></div>
  </div>
</template>

<script>
import AxiosMixin from '../mixins/AxiosMixin'
import LoadingIcon from '../Shared/LoadingIcon.vue'
import { ErrorBanner } from '@springbig/sb-components'
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'

export default {
  props: {
    currentAdvertiser: Object,
  },

  name: 'Insights',

  mixins: [AxiosMixin],

  components: {
    ErrorBanner,
    LoadingIcon
  },

  data() {
    return {
      isLoading: false,
      iframeUrl: null
    }
  },

  created() {
    this.getIframe()
  },

  methods: {
    async getIframe() {
      this.axiosMethod({
          url: `/insights?brand_id=${this.currentAdvertiser.id}`,
          methodType: 'get',
          onSuccess: this.handleResponse,
          onError: this.handleFailure
        })
    },

    async handleResponse(resp) {
      this.iframeUrl = resp.url
      this.loading = false

      const frameOptions = { 
        url: this.iframeUrl, 
        container: '#quicksight-container',
        resizeHeightOnSizeChangedEvent: true
      }
      const contentOptions = { 
        toolbarOptions: { 
          export: true, 
          reset: true
        }
      }
      const embeddingContext = await createEmbeddingContext()
      embeddingContext.embedDashboard(frameOptions, contentOptions)
    },

    handleFailure() {
      alert('Failed to load Dashboard')
    },
  },
}
</script>

<style lang="sass">
@import '../../assets/sass/colors'

#quicksight-container
  width: 100%
  min-height: 90vh
</style>